import { render, staticRenderFns } from "./Metalicos.vue?vue&type=template&id=91d5095a&"
import script from "./Metalicos.vue?vue&type=script&lang=js&"
export * from "./Metalicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports